import {Component, inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {ILocation} from '../../../typing/location.interface';
import {LocationService} from '../../../services/location.service';
import { MessageService } from '../../../services/message.service';
import { CloseButtonComponent } from '../../close-button/close-button.component';

@Component({
    selector: 'app-address-edit-form',
    standalone: true,
    imports: [
        FormsModule,
        MatButton,
        MatDialogContent,
        MatFormField,
        MatInput,
        MatLabel,
        ReactiveFormsModule,
        CloseButtonComponent,
        MatDialogTitle,
    ],
    templateUrl: './address-edit-form.component.html',
    styleUrl: './address-edit-form.component.scss'
})
export class AddressEditFormComponent implements OnInit{
    addressForm: FormGroup;
    public data: ILocation = inject(MAT_DIALOG_DATA);
    private locationService = inject(LocationService);
    private messageService = inject(MessageService);

    constructor(
        private fb: FormBuilder,
        protected dialogRef: MatDialogRef<AddressEditFormComponent>
    ) {
        this.addressForm = this.fb.group({
            address: ['', [Validators.required]],
            longitude: ['', [Validators.required]],
            latitude: ['', [Validators.required]],
        });
    }

    ngOnInit(): void {
        if (!this.data) { return; }

        this.addressForm.patchValue({
            address: this.data.address,
            longitude: this.data.longitude,
            latitude: this.data.latitude,
        });
    }

    onSubmit(): void {
        const request = this.data?.id ?
            this.locationService.updateLocation(this.data.id, this.addressForm.value) :
            this.locationService.createLocation(this.addressForm.value);
        request.subscribe({
            next: result => {
                this.messageService.successMessage('Адрес сохранен');
                this.dialogRef.close(result);
            },
            error: err => {
                this.messageService.errorMessage(err.message);
                this.dialogRef.close();
            }
        });
    }
}
